
import { Star } from "lucide-react";
import { useLanguage } from "@/components/LanguageContext";
import { useLanguagePath } from "@/utils/language";

interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
}

const TestimonialCard = ({ quote, author, role }: TestimonialCardProps) => (
  <div className="bg-baby-powder dark:bg-gray-800 p-8 rounded-xl shadow-ios hover:shadow-md transition-shadow">
    <div className="mb-4">
      <Star className="h-8 w-8 text-flame" />
    </div>
    <p className="text-slate-gray-dark dark:text-gray-300 mb-4 italic">{quote}</p>
    <div>
      <p className="font-semibold text-black dark:text-white">{author}</p>
      <p className="text-slate-gray-light dark:text-gray-400 text-sm">{role}</p>
    </div>
  </div>
);

export const Testimonials = () => {
  const { t } = useLanguage();
  const { getPath } = useLanguagePath();
  
  return (
    <div id="testimonials" className="py-24 bg-slate-gray-light/10 dark:bg-gray-900/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-black dark:text-white mb-4">
            {t('landing.testimonials.title')}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <TestimonialCard
            quote={t('landing.testimonials.testimonial1.quote')}
            author={t('landing.testimonials.testimonial1.author')}
            role={t('landing.testimonials.testimonial1.role')}
          />
          <TestimonialCard
            quote={t('landing.testimonials.testimonial2.quote')}
            author={t('landing.testimonials.testimonial2.author')}
            role={t('landing.testimonials.testimonial2.role')}
          />
          <TestimonialCard
            quote={t('landing.testimonials.testimonial3.quote')}
            author={t('landing.testimonials.testimonial3.author')}
            role={t('landing.testimonials.testimonial3.role')}
          />
        </div>
      </div>
    </div>
  );
};
